import changeCart from './changeCart';
import { clearWarrantyStorageForProduct } from './warrantySelection';

export const removeCartLineAndWarranty = async ({
  lineItemKey,
  warrantyLineItemKey,
  parentProductId,
}) => {
  if (!lineItemKey) return;

  if (warrantyLineItemKey) {
    await changeCart(warrantyLineItemKey, 0);
    if (parentProductId) {
      clearWarrantyStorageForProduct(parentProductId);
    }
  }

  await changeCart(lineItemKey, 0);
};

export const syncCartLineAndWarrantyQuantity = async ({
  lineItemKey,
  warrantyLineItemKey,
  quantity,
}) => {
  if (!lineItemKey || quantity < 1) return;

  await changeCart(lineItemKey, quantity);

  if (warrantyLineItemKey) {
    await changeCart(warrantyLineItemKey, quantity);
  }
};
